/**
 * WeaponScythe — hooked reaper blade on a long pole.
 * Pole runs vertically on the right side; a wide curved blade sweeps
 * to the upper-left from the pole top, with a downward hook at the far end.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponScythe() {
  return (
    <g>
      {/* Pole / staff */}
      <rect x="22"  y="0"  width="1.5" height="22" rx="0.5" fill="#7a6a5a"/>
      {/* Pole accent */}
      <rect x="22.4" y="1" width="0.4" height="20" rx="0.2" fill="#9a8a78" opacity="0.5"/>

      {/* Blade body — horizontal sweep to the left */}
      <rect x="8"   y="0.5" width="15" height="2.5" rx="1"   fill="#c0d8f0"/>
      {/* Blade top edge highlight */}
      <rect x="9"   y="0.5" width="13" height="0.8" rx="0.4" fill="#e0f0ff" opacity="0.7"/>

      {/* Hook at the far (left) end — curves downward */}
      <rect x="6"   y="2"   width="3.5" height="5.5" rx="1.8" fill="#c0d8f0"/>
      {/* Inner cut of hook (negative space look) */}
      <rect x="7.5" y="3"   width="2"   height="4"   rx="1"   fill="#a8c8e8" opacity="0.5"/>

      {/* Back spine of blade (darker) */}
      <rect x="9"   y="2.5" width="14" height="1"   rx="0.4" fill="#90b0c8" opacity="0.6"/>
    </g>
  );
}
